import type { FC, ReactElement, ReactNode } from 'react';

import type { IconProps } from '../Icons/BaseIcon';

export enum CalloutType {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
}

export type CalloutOverrides = {
  Icon: FC<IconProps>;
  iconColor: string;
  background: string;
  borderStyle: string;
  color: string;
  padding?: string;
};

export interface CalloutProps {
  headline?: string;
  type?: CalloutType;
  overrides?: Partial<CalloutOverrides>;
  customIcon?: ReactElement;
  action?: ReactNode;
  hideIcon?: boolean;
  className?: string;
  withBorder?: boolean;
  rounded?: boolean;
  hasCloseButton?: boolean;
  iconOnTop?: boolean;
  onCloseClick?: () => void;
  dark?: boolean;
  children?: ReactNode;
}
